import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
  tablist: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._8,
  },
  pill: {
    whiteSpace: 'nowrap',
    flexShrink: 0,
    fontWeight: 600,
  },
}));
